'use client';

import { useTranslations } from 'next-intl';
import { NotFoundButtons } from './not-found-buttons';
import { PromotedPosts } from './promoted-posts';

export function NotFoundPage() {
  const t = useTranslations('Blog.NotFound');
  return (
    <div className="not-found-page">
      <section className="not-found-hero">
        <p className="not-found-code">404</p>
        <h1 className="not-found-title">{t('Title')}</h1>
        <p className="not-found-description">
          <span>{t('Description1')}</span>
          <span>{t('Description2')}</span>
        </p>
        <div className="not-found-actions">
          <NotFoundButtons />
        </div>
      </section>
      <PromotedPosts />
    </div>
  );
}
